import React, { ChangeEvent, useCallback } from 'react'
import {
  CAlert,
  CButton,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CForm,
  CFormInput,
  CFormSelect,
  CFormSwitch,
  CRow,
  CTabContent,
} from '@coreui/react-pro'
import { useStore } from 'effector-react'
import {
  $clientOptions,
  $errorExchanger,
  $exchanger,
  clientDataMounted,
  setExchanger,
  submitCreateExchanger,
} from './model'
import { AutoComplete, Typography } from 'antd'
import { debounce } from 'lodash'

const TYPE = [
  {
    id: 1,
    name: 'exchanger',
  },
  {
    id: 2,
    name: 'partner',
  },
]

export const CreateExchanger = () => {
  const exchanger = useStore($exchanger)
  const clientOptions = useStore($clientOptions)
  const errorExchanger = useStore($errorExchanger)

  const handleChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    let value
    if (event.currentTarget.type === 'checkbox') {
      value = (event.currentTarget as HTMLInputElement).checked
    } else {
      value = event.currentTarget.value
    }
    setExchanger({
      ...exchanger,
      [event.currentTarget.name]: value,
    })
  }

  const debounceLoadData = useCallback(debounce(clientDataMounted, 1000), [])

  const handleGetClient = (id: string) => {
    if (id.length >= 3) {
      debounceLoadData({ id })
    }
  }

  const handleChangeAutoComplete = (value: string) => {
    setExchanger({
      ...exchanger,
      name: value,
    })
  }

  const handleOnSelect = (value: string) => {
    const ownerId = Number(
      clientOptions.find((item) => item.value === value)?.id,
    )
    setExchanger({
      ...exchanger,
      created: false,
      name: value,
      ownerId,
    })
  }

  return (
    <CCard className="mb-4">
      <CCardHeader className="d-sm-flex justify-content-between align-items-center">
        <strong>Create exchanger</strong>
      </CCardHeader>
      <CCardBody>
        {exchanger.created && (
          <CAlert color="success">Exchanger successfully created</CAlert>
        )}
        {errorExchanger.message.length > 0 && (
          <CAlert color="danger">Error code: {errorExchanger.message}</CAlert>
        )}
        <CTabContent className="pt-3">
          <CForm>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormSwitch
                  label="Activate exchanger"
                  id="active"
                  name="active"
                  type="checkbox"
                  checked={exchanger.active}
                  onChange={handleChange}
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol sm={4} className="d-flex flex-column">
                <Typography.Text>Exchanger owner</Typography.Text>
                <AutoComplete
                  onChange={(value, option) => handleChangeAutoComplete(value)}
                  onSelect={handleOnSelect}
                  value={exchanger.name}
                  options={clientOptions}
                  style={{ width: 300 }}
                  onSearch={(text) => handleGetClient(text)}
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormInput
                  label="Name"
                  id="frontName"
                  name="frontName"
                  value={exchanger.frontName}
                  onChange={handleChange}
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormInput
                  label="Internal name"
                  id="internalName"
                  name="internalName"
                  value={exchanger.internalName}
                  onChange={handleChange}
                />
              </CCol>
            </CRow>
            <CRow className="mb-3">
              <CCol sm={4}>
                <CFormSelect
                  label="Type"
                  id="type"
                  name="type"
                  value={exchanger.type}
                  onChange={handleChange}
                >
                  <option>Choose source type</option>
                  {TYPE.map((type) => (
                    <option value={type.name}>{type.name}</option>
                  ))}
                </CFormSelect>
              </CCol>
            </CRow>
            <CButton
              className="mb-3"
              onClick={() => {
                submitCreateExchanger(exchanger)
              }}
            >
              Save
            </CButton>
          </CForm>
        </CTabContent>
      </CCardBody>
    </CCard>
  )
}
